import { Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface EmptyReasonDefinitionContainerProps {
  icon: ReactNode;
  primaryText: ReactNode;
  secondaryText: ReactNode;
}

export const EmptyReasonDefinitionContainer = ({
  icon,
  primaryText,
  secondaryText,
}: EmptyReasonDefinitionContainerProps) => {
  return (
    <Stack
      p={2}
      mt={-2}
      spacing={1.5}
      height="100%"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Typography variant="h3">{icon}</Typography>
      <Stack>
        <Typography variant="body1" color="text.secondary">
          {primaryText}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {secondaryText}
        </Typography>
      </Stack>
    </Stack>
  );
};
